import { render } from "./RoleCard.vue?vue&type=template&id=26bf66f6&ts=true"
import script from "./RoleCard.vue?vue&type=script&lang=ts"
export * from "./RoleCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__